var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({staticClass:"control-element",attrs:{"elevation":"2","x-large":""},on:{"click":function($event){return _vm.$emit('clicked')}}},'v-btn',_vm.block,false),[_vm._v(_vm._s(_vm.txt))])}
var staticRenderFns = []

export { render, staticRenderFns }